module.exports = __webpack_public_path__ + "static/peta-7ce4bba5b40e0fb81b73f0cfc7563191.jpeg";